import { createClientOnlyFn } from "@tanstack/react-start";

export const initBrowserGlitchTipClient = createClientOnlyFn(async () => {
  const { initBrowserGlitchTip } = await import("./glitchtip-browser");
  initBrowserGlitchTip();
});
